import { getCookie } from '../../../../utils/helpers';

type TokenGetter = () => Promise<string | null>;
type EmailGetter = () => string | null;

const AUTH_TOKEN_COOKIE = 'app_access_token';

let tokenGetter: TokenGetter = async () => getCookie(AUTH_TOKEN_COOKIE);
let emailGetter: EmailGetter = () => null;

export function setAuthTokenGetter(fn: TokenGetter) {
  tokenGetter = fn;
}

export function getAccessToken(): Promise<string | null> {
  return tokenGetter();
}

export function setUserEmailGetter(fn: EmailGetter) {
  emailGetter = fn;
}

export function getUserEmail(): string | null {
  return emailGetter();
}

export async function createAuthJsonHeaders(
  headers: Record<string, string> = {}
): Promise<Record<string, string>> {
  const token = await getAccessToken();

  return {
    'Content-Type': 'application/json',
    ...headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
}
